exports.connect = {
	url: "https://api.campinglabaie.camp/"
}
